import {useEffect, useCallback} from 'react'
import {useSiteCustomPreferences} from '../../hooks/use-site-custom-preferences'
import {STORAGE_KEY, COOKIE_NAMES} from '../../constants'
import {hasUserGivenConsent} from '../../utils/custom-utils'

const CookieConsent = () => {
    const {getcustomPreferencevalue} = useSiteCustomPreferences()
    const consentType = getcustomPreferencevalue('pwaEvidononetrust')
    const oneTrustScript = getcustomPreferencevalue('pwaOneTrustScript')
    const onetrustLiveMode = getcustomPreferencevalue('pwaOnetrustLiveModeEnabled')
    const oneTrustEnabled = consentType === 'onetrust'

    const loadOneTrustScript = useCallback(() => {
        const existingScript = document.getElementById('onetrust-script')
        if (existingScript) existingScript.remove()
        const parser = new DOMParser()
        const doc = parser.parseFromString(oneTrustScript, 'text/html')
        const scriptElement = doc.querySelector('script')
        if (scriptElement) {
            const newScript = document.createElement('script')
            newScript.id = 'onetrust-script'
            Array.from(scriptElement.attributes).forEach((attr) => {
                newScript.setAttribute(attr.name, attr.value)
            })
            if (!onetrustLiveMode) {
                newScript.setAttribute('data-document-language', 'true')
            }
            document.head.appendChild(newScript)
        }
    }, [oneTrustScript, onetrustLiveMode])

    useEffect(() => {
        if (typeof window === 'undefined' || !oneTrustEnabled) return
        if (document.getElementById('onetrust-script') || hasUserGivenConsent(consentType)) {
            return
        }
        window.OptanonWrapper = function () {
            const cookie = document.cookie
                .split('; ')
                .find((row) => row.startsWith(`${COOKIE_NAMES.onetrust}=`))
            if (cookie) {
                const decoded = decodeURIComponent(cookie.split('=')[1] || '')
                if (decoded.includes('groups=') || decoded.includes('isIABGlobal=false')) {
                    localStorage.setItem(STORAGE_KEY, 'true')
                }
            }
        }

        loadOneTrustScript()
    }, [oneTrustEnabled, consentType])

    return null
}

export default CookieConsent
